import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import {userConstants} from "../../constants/userConstants";

export const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => (
        localStorage.getItem(userConstants.ACCESS_TOKEN)
            ? <Component {...props} />
            : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
    )} />
);
